import { render, staticRenderFns } from "./baseCity.vue?vue&type=template&id=2fd3922c&"
import script from "./baseCity.vue?vue&type=script&lang=js&"
export * from "./baseCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd3922c')) {
      api.createRecord('2fd3922c', component.options)
    } else {
      api.reload('2fd3922c', component.options)
    }
    module.hot.accept("./baseCity.vue?vue&type=template&id=2fd3922c&", function () {
      api.rerender('2fd3922c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/baseCity.vue"
export default component.exports